export enum InputType {
    Number = 1,
    Text,
    Select,
    Checkbox,
    Date,
    Time,
}
